// What the Today page offers the cards of its forecasted days through context. A page that doesn't set it (the calendar's day review)
// shows no Availability button.
export const FORECAST_TOOLS = 'todayForecastTools';

export type ForecastTools = {
  /** Checks again whether Adapt Forecast is needed, after a change to the day's training or availability. */
  refreshAdaptIndicator: () => void;
};
